<script setup>

import ServiceStartDate from "src/composables/ServiceStartDate";
import { computed, ref } from "vue";
import Utilities from "src/composables/Utilities";
import Tdsps from "src/composables/Tdsps";

defineProps({
  show_edit: {
    type: Boolean,
    default: true
  }
})

const { action, selected_start_date } = ServiceStartDate();
const { format_date } = Utilities();
const expanded = ref(true);
</script>

<template>
  <q-list bordered class="q-pa-md q-pa-lg-lg bg-white more-rounded-borders">
    <q-expansion-item v-model="expanded" header-class="text-bold" header-style="font-size: 21px"
                      icon="event" label="Start Date">
      <q-card>

        <q-card-section>
          <div>
            <div class="flex q-gutter-x-sm text-100">
              <div class="text-blue-grey-6"> Switch Type:</div>
              <div class="text-bold">{{ action }}</div>
            </div>
            <div class="flex q-gutter-x-sm text-100">
              <div class="text-blue-grey-6"> Start Date:</div>
              <div class="text-bold">{{ format_date(selected_start_date) }}</div>
            </div>
          </div>

          <div class="text-right">
            <q-btn v-if="show_edit" flat color="primary" no-caps class="text-bold bg-blue-1 text-primary"
                   label="Change Start Date"
                   to="/order/start_date"></q-btn>
          </div>
        </q-card-section>

      </q-card>

    </q-expansion-item>
  </q-list>
</template>


<style scoped>

</style>
